<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form
          :model="filter"
          inline
          size="mini"
          label-width="100px"
          @submit.native.prevent="search"
        >
          <el-form-item
            v-for="item in filters"
            :key="item.prop"
            :label="item.label"
          >
            <el-select
              v-model="filter[item.prop]"
              clearable
              filterable
              placeholder="全部"
              :loading="dictLoading"
              :disabled="!dictReady"
            >
              <el-option
                v-for="option in dict[item.dict] || []"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button
            type="primary"
            size="small"
            :loading="loading"
            @click="search"
          >
            查询
          </el-button>
          <el-button class="orange-btn" size="small" @click="reset">
            重置
          </el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-tabs v-model="activeTab" class="rule-tabs">
          <el-tab-pane label="基础发货周期规则" name="BASIC" />
          <el-tab-pane label="活动发货周期规则" name="ACTIVITY" />
        </el-tabs>
      </template>

      <basic-rule-config
        v-if="activeTab === 'BASIC'"
        ref="ruleConfig"
        :filter-data="filter"
        :dict="dict"
        :dict-loading="dictLoading"
        :dict-ready="dictReady"
        :maxTableHeight="maxTableHeight"
        @loading-change="loading = $event"
      />
      <activity-rule-config
        v-else
        ref="ruleConfig"
        :filter-data="filter"
        :dict="dict"
        :dict-loading="dictLoading"
        :dict-ready="dictReady"
        :maxTableHeight="maxTableHeight"
        @loading-change="loading = $event"
      />
    </table-panel>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import { options, responseData, errorText } from './model'
import BasicRuleConfig from './components/BasicRuleConfig'
import ActivityRuleConfig from './components/ActivityRuleConfig'
import tableMixin from '@/utils/tableMixin'

const createFilter = () => ({
  classCode: '',
  productionLogisticsType: '',
  priorityCode: '',
  supplyChannel: ''
})

const dictionaryKeys = [
  'shelfOptions',
  'productionOptions',
  'priorityOptions',
  'channelOptions',
  'fieldOptions',
  'operatorOptions',
  'unitOptions',
  'resultTypeOptions',
  'sourceFieldOptions',
  'configTypeOptions'
]

export default {
  name: 'PackagePeriodRules',
  components: {
    BasicRuleConfig,
    ActivityRuleConfig
  },
  mixins: [pagePathMixin, tableMixin],
  data () {
    return {
      activeTab: 'BASIC',
      filter: createFilter(),
      filters: [
        {
          prop: 'classCode',
          label: '上架分类',
          dict: 'shelfOptions'
        },
        {
          prop: 'productionLogisticsType',
          label: '生产物流分类',
          dict: 'productionOptions'
        },
        {
          prop: 'priorityCode',
          label: '优先级',
          dict: 'priorityOptions'
        },
        {
          prop: 'supplyChannel',
          label: '供应渠道',
          dict: 'channelOptions'
        }
      ],
      dict: {},
      dictLoading: false,
      dictReady: false,
      dictError: '',
      dictId: 0,
      loading: false
    }
  },
  created () {
    this.loadDictionary()
  },
  beforeDestroy () {
    this.dictId++
  },
  methods: {
    async loadDictionary () {
      const id = ++this.dictId
      this.dictLoading = true
      this.dictReady = false
      this.dictError = ''
      this.dict = {}

      try {
        // 字典接口无请求参数，一次返回筛选和编辑使用的全部选项。
        const response = await this.$q.shippingPeriod.ruleDict()
        const data = responseData(response)
        if (id !== this.dictId) return

        this.dict = Object.fromEntries(
          dictionaryKeys.map(key => [key, options(data && data[key])])
        )
        this.dictReady = true
      } catch (error) {
        if (id === this.dictId) {
          this.dictError = errorText(error)
        }
      } finally {
        if (id === this.dictId) {
          this.dictLoading = false
        }
      }
    },
    search () {
      return this.$refs.ruleConfig.search()
    },
    async reset () {
      this.filter = createFilter()
      await this.$nextTick()
      return this.search()
    }
  }
}
</script>

<style src="./style.css"></style>
<style scoped>
.rule-tabs >>> .el-tabs__header {
  margin: 0;
}
</style>
